const colors = {
  primary: "#FDD02E",
  dark: "#121a3a"
};

export default {
  colors
};
